import { useEffect, useRef } from 'react';

const useParallaxEffect = (intensity = 0.3) => {
    const ref = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (ref.current) {
                const scrollPosition = window.scrollY;
                ref.current.style.backgroundPositionY = `${scrollPosition * intensity}px`;
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [intensity]);

    return ref;
};

export default useParallaxEffect;